<div id="line" #line class="h-100 w-100">
    <p *ngIf="!lineData.length" class="mt">No Data</p>
</div>